export default __webpack_public_path__ + "static/media/file-icon-generic.c1449e50.svg";